import isNumber from 'lodash/isNumber';
import reduce from 'lodash/reduce';
import upperCase from 'lodash/upperCase';
import { DEALER_LOCATOR_ENDPOINT } from '@yme/common/endpoints';
import { getFilteredDataList } from '@yme/components/DealerLocator/redux/helpers';
import { DEFAULT_LANGUAGE_CODE } from '@yme/services/i18n';
import { Network } from '@yme/services/network';
const getQuery = () => `
  query GetDealersByVicinityId ($vicinityIds: [String]) {
    GetDealersByVicinityId(vicinityIds: $vicinityIds) {
      vicinityId
      name
      region
      country
      city
      addressLines
      zipCode
      telephoneNumbers
      email
      websites
      logoImageUrl
      latitude
      longitude
      serviceIds
    }
  }
`;
const hasValidCoords = (dealer) => {
    if (!dealer)
        return false;
    return isNumber(dealer.latitude) && isNumber(dealer.longitude);
};
export const getDealersByVicinityId = async (vicinityIds, coordinates, language = upperCase(DEFAULT_LANGUAGE_CODE)) => {
    const response = await Network.post(DEALER_LOCATOR_ENDPOINT, {
        query: getQuery(),
        variables: {
            vicinityIds,
        },
    });
    const result = reduce(response.data.data.GetDealersByVicinityId, (acc, dealer) => {
        const isValid = hasValidCoords(dealer);
        if (isValid) {
            acc.push({
                ...dealer,
                openingHours: {
                    ...dealer.openingHours?.[upperCase(language)],
                },
            });
        }
        return acc;
    }, []);
    return coordinates ? getFilteredDataList(result, coordinates) : result;
};
